import { render, staticRenderFns } from "./people.vue?vue&type=template&id=33254867&scoped=true&"
import script from "./people.vue?vue&type=script&lang=js&"
export * from "./people.vue?vue&type=script&lang=js&"
import style0 from "./people.vue?vue&type=style&index=0&id=33254867&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33254867",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33254867')) {
      api.createRecord('33254867', component.options)
    } else {
      api.reload('33254867', component.options)
    }
    module.hot.accept("./people.vue?vue&type=template&id=33254867&scoped=true&", function () {
      api.rerender('33254867', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/task_manage/work_task/form/components/people.vue"
export default component.exports